import React from "react";
import "./input.css";

/* -------------------------------
   ✨ 1️⃣ Normal Text Input
-------------------------------- */
export function FloatingInput({ label, type = "text", onFocus, onChange, onBlur, ...props }) {
  const inputId = props.id || `input-${props.name || Math.random()}`;

  const handleFocus = (e) => {
    e.target.select(); // auto-select value
    if (onFocus) onFocus(e);
  };


  const handleChange = (e) => {
    if (onChange) onChange(e);
  };

  const handleBlur = (e) => {
    if (onBlur) onBlur(e);
  };

  return (
    <div className="floating-input-wrapper">
      <input
        id={inputId}
        type={type}
        placeholder=" "
       // readOnly={props.readOnly}
       // value={props.value ?? ""}
        onFocus={handleFocus}
        onChange={handleChange}
        onBlur={handleBlur}
        {...props} // props should NOT override critical bindings
      />
      {label && <label htmlFor={inputId}>{label}</label>}
    </div>
  );
}
export default FloatingInput;